import { useEffect, useState } from "react";

export default function useCountdown(targetIso) {
  const compute = () => {
    if (!targetIso) return { total: 0, h: 0, m: 0, s: 0, expired: true };
    const diff = new Date(targetIso).getTime() - Date.now();
    if (diff <= 0) return { total: 0, h: 0, m: 0, s: 0, expired: true };
    const total = Math.floor(diff / 1000);
    return {
      total,
      h: Math.floor(total / 3600),
      m: Math.floor((total % 3600) / 60),
      s: total % 60,
      expired: false,
    };
  };
  const [t, setT] = useState(compute);
  useEffect(() => {
    setT(compute());
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, [targetIso]);
  return t;
}
